import {FormControlLabel, Switch, SwitchProps} from '@mui/material';
import React from 'react';

export type AppSwitchProps = SwitchProps & {
    label?: string;
};
export const AppSwitch: React.FC<AppSwitchProps> = ({label, value, ...rest}) => {
    return <FormControlLabel control={<Switch {...rest} sx={{m: 1}} value={value} />} label={label} />;
};

export default AppSwitch;
